import * as React from "react";
import { styled, Stack, Typography, Link, Fade, AppBar as MuiAppBar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
export interface ConfigSelectBannerProps {
  visible: boolean;
  nbSelection: number;
  onClearClick: React.MouseEventHandler;
}

const ConfigSelectBanner: React.FC<ConfigSelectBannerProps> = (props) => {
  const { t } = useTranslation();
  const { visible, nbSelection, onClearClick } = props;

  return (
    <Fade in={visible}>
      <AppBar position="absolute">
        <Container direction="row" justifyContent="space-between">
          <Stack direction="row" alignItems="center">
            <Typography variant="subtitle2" fontWeight={600}>
              {t("banner:configSelectBanner.body.contentsSelected", { count: nbSelection })}
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center">
            <Link component="button" color="common.white" underline="hover" onClick={onClearClick} fontWeight={500}>
              {t("common:unselectAll")}
              <CloseIcon sx={{ ml: 0.5 }} />
            </Link>
          </Stack>
        </Container>
      </AppBar>
    </Fade>
  );
};

export default ConfigSelectBanner;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "visible",
})(({ theme }) => ({
  top: 64,
  left: "50vw",
  width: "50vw",
  flexDirection: "row",
  justifyContent: "space-between",
  backgroundColor: theme.palette.primary.main,
  boxShadow: theme.palette.mode === "dark" ? theme.shadows[6] : theme.shadows[2],
  transition: "opacity .3s",
  padding: `${theme.spacing(1.5)} ${theme.spacing(3)}`,

  ".Mui-Container-root": {
    maxWidth: "100%",
  },
  [theme.breakpoints.up("lg")]: {
    left: "60vw",
    width: "40vw",
  },
}));

const Container = styled(Stack)(({ theme }) => ({
  maxWidth: "100%",
  width: "100%",
}));
